module.exports = __webpack_public_path__ + "img/vertical_7_6_3016.c6880155.png";